/*
 eギフト用のjsライブラリ
*/
const EGIFT_CARD = {
//  'default' : { 'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/egift-thanks-classic-2.jpg?v=1633053628', 'text_color' : '#000000', 'text_bg_color' : '#ffffff' },
//  'default' : { 'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/products/22940_916_1200x.jpg?v=1635317801', 'text_color' : '#000000', 'text_bg_color' : '#ffffff' },
//<video class="card-video" src="https://cdn.shopify.com/s/files/1/0036/3721/5277/files/211117_01_present.mp4?v=1637186065" poster="https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mc01_small_a_rgb_03.png?v=1637304675" muted autoplay playsinline loop></video>

  'default' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/egift-thanks-classic-2.jpg?v=1633053628',
    'text_color' : 'rgba(0,0,0,.86)',
    'text_bg_color' : '#fff',
    'button_bg_color' : '#cc7714'
  },
  'mrc_egift' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/egift-thanks-classic-2.jpg?v=1633053628',
    'text_color' : 'rgba(0,0,0,.86)',
    'text_bg_color' : '#fff',
    'button_bg_color' : '#cc7714',
    'select' : true
  },
  '2021_hh_1' : {
    'video' : '//videos.ctfassets.net/pd8dp6of2c4d/3BnZjEfxOeLQeqK5fhiUiH/b54322c1f37cb4418d6ceb278af32ab6/211129_01_present_small_compress.mp4',
    'image' : '//images.ctfassets.net/pd8dp6of2c4d/6rzGGRFEhfA8MQxCbYc5ME/f64ae8d0b61427bffc30936421caab7e/mc01_small_a_rgb_03.png',
    'joint' : '//images.ctfassets.net/pd8dp6of2c4d/9uMOebcyrIvgL0Jw5Zdrn/e090a1c703897c768a20ef5f0ef6cbc8/mc01_pattern.png',
    'text_color' : 'rgb(32, 46, 173)',
    'text_bg_color' : 'rgb(240, 146, 181)'
  },
  '2021_hh_2' : {
    'video' : '//videos.ctfassets.net/pd8dp6of2c4d/3B7y2hD37ZVlXFjYGATxm7/4396de4f14cfe0cd917d488e2d12dd9b/211129_02_toumin_small_compress.mp4',
    'image' : '//images.ctfassets.net/pd8dp6of2c4d/3phEJ5hg7xiAo5VxYXhn0W/71be3cee92948f3f080ba35173ee90ee/mc02_small_a_resize_rgb_03.png',
    'joint' : '//images.ctfassets.net/pd8dp6of2c4d/4ZYHCtEcOs7ZtHqcBzUWuB/7b25c39f5e9d61951649e81c593199c2/mc02_pattern.png',
    'text_color' : 'rgb(32, 52, 55)',
    'text_bg_color' : 'rgb(131, 204, 210)'
  },
  '2021_hh_3' : {
    'video' : '//videos.ctfassets.net/pd8dp6of2c4d/1ymx2QZg878CeJydTchFm0/dec45e933b92902c0db3ff858409ce9c/211129_03_window_small_compress.mp4',
    'image' : '//images.ctfassets.net/pd8dp6of2c4d/4Un0oPu4lhl6ntNs3L0KjO/9ed4c28b8f778cb6054c2674353759c4/mc03_small_a_rgb_02.png',
    'joint' : '//images.ctfassets.net/pd8dp6of2c4d/5H8S5n5goKwMDtyDjFRBpg/d840b1afba99f35360cca35285e16062/mc03_pattern.png',
    'text_color' : 'rgb(255, 255, 255)',
    'text_bg_color' : 'rgb(0, 129, 204)'
  },
  '2022_hny_1' : {
    'video' : '//videos.ctfassets.net/pd8dp6of2c4d/3A64BpgrVyhPZXeFXXcwWT/806c04fd783c2d6b9e09a554b9ac237e/211217_04_happynewyear_small__2_.mp4',
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/greeting_01-2_800x.png?v=1640633489',
    'joint' : 'https://images.ctfassets.net/pd8dp6of2c4d/6U5qTbST0kCM13379eOk9U/bede99b5ae547dccfbec2ae2a661a675/mc04_small_a_none_rgb_03.png',
    'text_color' : '#FFFFFF',
    'text_bg_color' : '#EA5504'
  },
  'mrc_2022_hny' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-2022-hny-min.jpg?v=1640635541',
    'text_color' : '#FFFFFF',
    'text_bg_color' : '#B90000',
    'button_bg_color' : '#C20000'
  },
  'mrc_2022_tora' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-2022-tora-min.jpg?v=1640635541',
    'text_color' : 'rgba(0,0,0,.86)',
    'text_bg_color' : '#F5EAD2',
    'button_bg_color' : '#C20000'
  },
  'mrc_thankyou' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-thankyou-min.jpg?v=1641902134',
    'text_color' : '#005F64',
    'text_bg_color' : '#FFFFFF',
    'button_bg_color' : '#005F64',
    'select' : true
  },
  'mrc_happybirthday' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-happybirthday-min.jpg?v=1641902134',
    'text_color' : '#5A5F4B',
    'text_bg_color' : '#F9F7F3',
    'button_bg_color' : '#5A5F4B',
    'select' : true
  },
  'mrc_congratulations' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-congratulations-min.jpg?v=1641902134',
    'text_color' : '#EBE6E1',
    'text_bg_color' : '#004096',
    'button_bg_color' : '#004096',
    'select' : true
  },
  'mrc_thankyou_flowers' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-thankyou-flowers.jpg?v=1646097969',
    'text_color' : '#FFFFFF',
    'text_bg_color' : '#AAB7FF',
    'button_bg_color' : '#AAB7FF',
    'select' : true
  },
  'mrc_happybirthday_candles' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-happybirthday-candle.jpg?v=1646097969',
    'text_color' : '#FF6400',
    'text_bg_color' : '#F7F7F3',
    'button_bg_color' : '#FF6400',
    'select' : true
  },
  'mrc_congratulations_cherry' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-congratulations-cherry.jpg?v=1646097969',
    'text_color' : '#00A064',
    'text_bg_color' : '#FCF5EE',
    'button_bg_color' : '#00A064',
    'select' : true
  },
  'mrc_congratulations_wedding' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-wedding.jpg?v=1663270455',
    'text_color' : '#FFFFFF',
    'text_bg_color' : '#A9BDAF',
    'button_bg_color' : '#A9BDAF',
    'select' : true
  },
  'mrc_have_good_time' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-have-good-time.jpg?v=1663268066',
    'text_color' : '#F3F3EF',
    'text_bg_color' : '#2F1600',
    'button_bg_color' : '#2F1600',
    'select' : true
  },
  'mrc_just_for_you' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-just-for-you.jpg?v=1663270140',
    'text_color' : '#FFFFFF',
    'text_bg_color' : '#B4A392',
    'button_bg_color' : '#B4A392',
    'select' : true
  },
  '2022_vl_1' : {
    'video' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mc_valentine_01_run_600.mp4?v=1642915742',
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/sceneby_arairio_01.png?v=1642917415',
    'text_color' : '#422F2A',
    'text_bg_color' : '#E5D9C1',
    'button_bg_color' : '#422F2A'
  },
  '2022_vl_2' : {
    'video' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mc_valentine_02_kitchen_600.mp4?v=1642915742',
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/sceneby_arairio_02.png?v=1642917415',
    'text_color' : '#F9EBE1',
    'text_bg_color' : '#233644',
    'button_bg_color' : '#233644'
  },
  '2022_vl_3' : {
    'video' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mc_valentine_03_letter_600.mp4?v=1642915742',
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/sceneby_arairio_03.png?v=1642917415',
    'text_color' : '#281C1A',
    'text_bg_color' : '#D8948B',
    'button_bg_color' : '#281C1A'
  },
  '2022_vl_4' : {
    'video' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mc_valentine_04_shoes_600.mp4?v=1642915742',
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/sceneby_arairio_04.png?v=1642917415',
    'text_color' : '#F9F1E4',
    'text_bg_color' : '#7F594C',
    'button_bg_color' : '#7F594C'
  },
  '2022_mothers_1' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/ayumi-hanamatsu-01.jpg?v=1650148195',
    'text_color' : '#ffffff',
    'text_bg_color' : '#f099b5',
    'button_bg_color' : '#f099b5'
  },
  '2022_mothers_2' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/ayumi-hanamatsu-02.jpg?v=1650148195',
    'text_color' : '#3a587d',
    'text_bg_color' : '#f4aa9f',
    'button_bg_color' : '#3a587d'
  },
  '2022_mothers_3' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/ayumi-hanamatsu-03.jpg?v=1650148195',
    'text_color' : '#586221',
    'text_bg_color' : '#c9d580',
    'button_bg_color' : '#586221'
  },
  '2022_hh_1' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/holidaycard_table.jpg?v=1669947872',
    'text_color' : '#F7F8F8',
    'text_bg_color' : '#283628',
    'button_bg_color' : '#283628'
  },
  '2022_hh_2' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/holidaycard_reindeer.jpg?v=1669947873',
    'text_color' : '#40220F',
    'text_bg_color' : '#F7F8F8',
    'button_bg_color' : '#40220F'
  },
  '2023_hny' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mrc-happynewyear-2023.jpg?v=1672150167',
    'text_color' : '#FFFFFF',
    'text_bg_color' : '#ADAAA3',
    'button_bg_color' : '#ADAAA3'
  },
  '2023_vl_1' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/valentinecard_letter.jpg?v=1673595612',
    'text_color' : '#461B1C',
    'text_bg_color' : '#F5F0E6',
    'button_bg_color' : '#461B1C'
  },
  '2023_vl_2' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/valentinecard_bird.jpg?v=1673595612',
    'text_color' : '#4F4B4D',
    'text_bg_color' : '#FFFFEE',
    'button_bg_color' : '#4F4B4D'
  },
  '2023_vl_3' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/valentinecard_present.jpg?v=1673595613',
    'text_color' : '#F5F7F7',
    'text_bg_color' : '#012E39',
    'button_bg_color' : '#012E39'
  },
  '2023_wd_1' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/whiteday_greeting01_1200x.jpg?v=1676964643',
    'text_color' : '#333120',
    'text_bg_color' : '#BDBBB5',
    'button_bg_color' : '#333120'
  },
  '2023_wd_2' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/whiteday_greeting02_1200x.jpg?v=1676964643',
    'text_color' : '#F2F2F2',
    'text_bg_color' : '#57685A',
    'button_bg_color' : '#57685A'
  },
  'mrc_goodluck' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/greeting_goodluck.jpg?v=1679026195',
    'text_color' : '#004100',
    'text_bg_color' : '#ABAA9B',
    'button_bg_color' : '#004100',
    'select' : true
  },
  'hlt_egift' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/hlt_egift.jpg?v=1701057844',
    'text_color' : '#80342F',
    'text_bg_color' : '#DED8D9',
    'button_bg_color' : '#80342F',
    'select' : true
  },
  'years_gift_2023' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/egift_years-gift-2023.jpg?v=1702002050',
    'text_color' : '#FEFEFE',
    'text_bg_color' : '#8D8368',
    'button_bg_color' : '#8D8368',
    'select' : true
  },
  'years_gift_2023a' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/egift_years-gift-2023.jpg?v=1702002050',
    'text_color' : '#FEFEFE',
    'text_bg_color' : '#8D8368',
    'button_bg_color' : '#8D8368',
    'select' : true
  },
  '2023_mothers' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/mothersday_2023.jpg?v=1682052952',
    'text_color' : '#E0E4E2',
    'text_bg_color' : '#1C584E',
    'button_bg_color' : '#1C584E',
    'select' : true
  },
  '2024_mothers' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/2024-mothersday_egift-card.jpg?v=1713140827',
    'text_color' : '#78462D',
    'text_bg_color' : '#F5E9D8',
    'button_bg_color' : '#5A686C',
    'select' : true
  },
  '2024_hh_1' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/egift_card_2024_holiday_table.jpg?v=1731211328',
    'text_color' : '#F7F8F8',
    'text_bg_color' : '#283628',
    'button_bg_color' : '#283628',
    'select' : true
  },
  '2024_hh_2' : {
    'image' : 'https://cdn.shopify.com/s/files/1/0036/3721/5277/files/egift_card_2024_holiday_reindeer.jpg?v=1731211328',
    'text_color' : '#40220F',
    'text_bg_color' : '#F7F8F8',
    'button_bg_color' : '#40220F',
    'select' : true
  }
}

/**
　設定を取得する
*/
function get_card_config(id) {
  if (EGIFT_CARD[id]) {
    return EGIFT_CARD[id];
  }
  return EGIFT_CARD['default'];
}

/**
 * select可能なものだけ取得する
 */
function get_select_card_list() {
  let list = [];
  for (let key in EGIFT_CARD) {
    let card = EGIFT_CARD[key];
    if (card && card.select == true) {
      list.push(card);
    }
  }
  return list;
}
